import type { AgentFirstContext, AgentFirstKey } from './agentFirst';

/** Open the one "Ask your agent" modal from anywhere; AppShell renders <AskAgentHost />. */

export interface AskAgentOptions {
  action: AgentFirstKey;
  ctx?: AgentFirstContext;
  /** The do-it-myself action, for "[Do it myself] instead" (only when the action has one). */
  onSelf?: () => void;
}

export type Listener = (ask: AskAgentOptions) => void;
export const askAgentListeners = new Set<Listener>();

export function openAskAgent(options: AskAgentOptions) {
  askAgentListeners.forEach((fn) => fn(options));
}
